// extracted by mini-css-extract-plugin
export var section = "_1w-1";
export var topNav = "_1w-0";